//basic
import React, { Component } from 'react';
import {toJS} from 'mobx';
import { inject, observer } from 'mobx-react';

//style
import './Customers.scss';

//api
import { api } from '../../functions/api';

//custom components
import Search from '../../components/basic/search';
import CustomButton from '../../components/basic/CustomButton';
import CustomTable from '../../components/complex/customTable';
import DeleteDialog from '../../components/global/deleteDialog';

import EditCustomer from './Edit/EditCustomer'

//material-ui
import { CircularProgress } from '@material-ui/core';

//other libraries
import queryString from 'query-string';
import Icon from '@mdi/react';
import { mdiDownload, mdiPlus, mdiUpload } from '@mdi/js'
import { debounce } from 'lodash'
import CustomSelect from '../../components/basic/CustomSelect'

@inject('translate')
@inject('internal')
@observer
export default class Customers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingPage: true,
            loadingTable: true,
            siblingsDialog: false,
            addEditDialog: false,
            changeItems: false,
            idFixedSet: 0,
            searchTerm: '',
            customer_created_at: null,
        }
    }

    componentDidMount() {
        this.props.internal.setRoute(this.props.history, this.props.location.pathname);
        this.props.internal.setHeaderTitle(this.props.translate.i18n.GLOBAL.MENU.CUSTOMERS);
    
        const URLqueryString = this.props.history.location.search
        let queries = queryString.parse(URLqueryString);

        let searchterm;
        if(queries) {
            if(queries.searchterm) {
                searchterm = queries.searchterm
                this.setState({searchTerm: searchterm})
            }
        }
        
        this.loadCustomers();
    }

    // definujeme ci sa ma reloadnut tabulka
    tableReload = false;

    // counter ktori sa zvacsuje pri kazdom api cale okrem pri mounte modulu
    // nedovuje aby sa tabulka zobrazila skor ako co pride aj posledna odpoved zo servera
    apiCallCounter = 0;

    tableHeader = [
        // {
        //     "title": "first_name",
        //     "numeric": false
        // },
        // {
        //     "title": "last_name",
        //     numeric: false,
        // },
        {
            "title": "username",
            sortBy: 'first_name',
        },
        {
            "title": "email",
            sortBy: 'email',
            numeric: false,
        },
        {
            title: 'consent_gdpr_at',
            sortBy: 'consent_gdpr_at',
        },
        {
            title: 'consent_newsletter_at',
            sortBy: 'consent_newsletter_at',
        },
        {
            title: 'created_at',
            sortBy: 'customer_created_at'
        },
        {
            title: "order_count",
            numeric: true,
            sortBy: 'orders_count',
        }
    ];
    tableBody = [
        // "first_name",
        // "last_name",
        "username",
        "email",
        'consent_gdpr_at',
        'consent_newsletter_at',
        'customer_created_at',
        "orders_count"
    ]

    dropDownMenuItems = [
        // {
        //     title: this.props.translate.i18n.MODULES.ADMINISTRATORS.MENU_ITEMS.EDIT,
        //     action: "edit",
        // },
    ];

    handleChangeRowsPerPage = (size) => {
        this.setState({
            loading: true
        });
        this.addQueryToUrl("page_size", size)
    }

    handleChangePage = (page) => {
        this.setState({
            loading: true
        });

        this.addQueryToUrl("page_number", page + 1)
    }

    handleSearch = debounce((searchTerm) => {

        if (searchTerm.length > 2) {
            this.tableReload = true;
            this.addQueryToUrl("searchterm", searchTerm)
        }
        else {
            this.addQueryToUrl("searchterm", "")
        }
    }, 500)

    handleSort = (dir, orderBy) => {
        this.setState({
            loading: true
        })
        
        this.addQueryToUrl("dir", dir,"by", orderBy)
    }

    addQueryToUrl = (param, value, param2 = null, value2 = null) => {
        this.tableReload = true;

        const URLqueryString = this.props.history.location.search
        let queries = queryString.parse(URLqueryString)
        queries[param] = value
        if(param2 && value2) {
            queries[param2] = value2
        }

        let new_path = this.props.location.pathname

        new_path += "?"
        for(let key in queries) {
            if(key) {
                new_path += key + "=" + queries[key] + "&"
            }
        }
        new_path = new_path.slice(0,-1)

        this.props.internal.pushRoute(new_path)
        this.loadCustomers()
    }

    loadCustomers = async (size = 10, page = 0, searchterm = "", by = "last_name", dir = "asc") => {
        if(this.tableReload) {
            this.setState({loadingTable: true})
            this.apiCallCounter++;
        }
        
        const URLqueryString = this.props.history.location.search
        let queries = queryString.parse(URLqueryString);
        
        const filters = {}
    
        let params = {
            // searchterm: searchterm,
            // page:{
            //     number:page,
            //     size:size,
            // },
            // order: [
            //     {
            //         by: by,
            //         dir: dir
            //     }
            // ]
        }

        if(queries) {
            
            if(queries.page_number) {
                page = queries.page_number
            }

            if(queries.page_size) {
                size = queries.page_size
            }
            
            params.page = {
                number: page,
                size,
            };

            if(queries.by) {
                by = queries.by
            }

            if(queries.dir) {
                dir = queries.dir
            }
            
            params.order = [
                { by, dir }
            ]

            if(queries.searchterm) {
                params.searchterm = queries.searchterm
            }

            if(queries.customer_created_at) {
                filters.customer_created_at = queries.customer_created_at
                params.filters = filters
            }

            if(queries.consent_gdpr_at) {
                filters.consent_gdpr_at = queries.consent_gdpr_at
                params.filters = filters
            }

            if(queries.consent_newsletter_at) {
                filters.consent_newsletter_at = queries.consent_newsletter_at
                params.filters = filters
            }
        }

        let load_data = await api({
            method:'get',
            url: 'customers',
            authorization: this.props.internal.user.access_token,
            params
        })


        if (load_data.success === true) {
            if (load_data.data) {
                this.props.internal.setDataForTable(load_data.data)
                this.setState({loadingTable: false})
            }
        }
        this.setState({loadingPage: false})

        if(this.tableReload) {
            this.apiCallCounter--;
            if(this.apiCallCounter === 0) {
                this.setState({loadingTable: false})
                this.tableReload = false;
            }
        }
    }

    openCloseDialogChangePosition = (refresh = false) => {
        this.setState({siblingsDialog: !this.state.siblingsDialog})
        if(refresh) {
            this.loadCustomers()
        }
    }

    handleOpenCloseDialog = (refresh = false) => {
        let actionEdit = toJS(this.props.internal.actionEdit)
        if(actionEdit.edit) {
            actionEdit = {
                edit: false,
                id: null
            }
            this.props.internal.setActionEdit(actionEdit)
        }
        else {
            this.setState({addEditDialog: !this.state.addEditDialog})
        }

        if(refresh) {
            this.loadCustomers()
        }
    }

    clickOnProductionStatus = async(id, status) => {
        let update_data = await api({
            method: 'patch',
            url: `products/dynamic-sets/${id}`,
            authorization: this.props.internal.user.access_token,
            params: {
                production: status
            }
        })

        if(update_data.success === true) {
            this.props.internal.setSnackbar(update_data.data.message, true)
            this.loadCustomers()
        }
    }

    handleDelete = async() => {
        let idFixedSet = toJS(this.props.internal.actionDeleteObj.id)

        //TODO: vymazat ked bude na testovacom serveri
        idFixedSet = 2

        let delete_data = await api({
            method: "delete",

            //TODO: vymazat ked bude na testovacom serveri
            // postman: true,
            
            url: `products/dynamic-sets/${idFixedSet}`,
            authorization: this.props.internal.user.access_token,
        })

        if(delete_data.success === true) {
            this.props.internal.setSnackbar(delete_data.data.message, true)
            this.loadCustomers();
            this.props.internal.setActionDelete();
        }
    }

    changeItems = (idFixedSet) => {
        this.setState({changeItems: !this.state.changeItems, idFixedSet: idFixedSet})
    }
    
    filterTable = (column, data) => {
        this.addQueryToUrl(column, data)
    }
    
    initiateExport = () => {
        const URLqueryString = this.props.history.location.search
        let queries = queryString.parse(URLqueryString);
    
        const filters = {}
    
        const params = {}
    
        if(queries) {
            if(queries.searchterm) {
                params.searchterm = queries.searchterm
            }
        
            if(queries.customer_created_at) {
                filters.customer_created_at = queries.customer_created_at
                params.filters = filters
            }
        
            if(queries.consent_gdpr_at) {
                filters.consent_gdpr_at = queries.consent_gdpr_at
                params.filters = filters
            }
        
            if(queries.consent_newsletter_at) {
                filters.consent_newsletter_at = queries.consent_newsletter_at
                params.filters = filters
            }
        }
        
        api({
            // method: 'post',
            url: 'customers/export',
            authorization: this.props.internal.user.access_token,
            params
        }).then(response => {
            if (response.success) {
                window.open(response.data.data.url, '_blank')
            }
        })
    }

    render () {
        return (
            this.state.loadingPage
                ?
                <CircularProgress className={'circular-progress'}/>
                :
                <div className={'fixed-sets'}>
                    {/* dialog pre upravovanie/vytvorenie */}
                    {(toJS(this.props.internal.actionEdit.edit)) &&
                        <EditCustomer
                            open={toJS(this.props.internal.actionEdit.edit)}
                            onClose={this.handleOpenCloseDialog}
                            title={this.props.translate.i18n.MODULES.CUSTOMERS.TITE_EDIT_CUSTOMER}
                        />
                    }
                    
                    <DeleteDialog
                        open={this.props.internal.actionDelete}
                        title={this.props.translate.i18n.MODULES['FIXED-SETS'].DELETE_FIXED_SET_TITLE}
                        content={this.props.translate.i18n.GLOBAL.ALERTS.DELETE_ITEM}
                        btn_cancel={this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                        btn_delete={this.props.translate.i18n.GLOBAL.BUTTONS.DELETE}
                        delete={this.handleDelete}
                    />
                    <div className={'flex space-between mb-first-line'}>
                        <Search placeholder={this.props.translate.i18n.MODULES.MENU.SEARCH} classes={'admin-search'} onChange={this.handleSearch} value={this.state.searchTerm}/>
                         <CustomButton
                            mystyle = {'btn-orange-bg border-radius-18'}
                            title = {this.props.translate.i18n.GLOBAL.MENU.EXPORT}
                            onClick = {this.initiateExport}
                        >
                            <Icon path = {mdiDownload} size = {1}/>
                        </CustomButton>
                    </div>
                    <div className={'first-line'}>
                        <div className={'flex'}>
                            <CustomSelect
                              title={this.props.translate.i18n.MODULES.CUSTOMERS.REGISTERED}
                              data={toJS(this.props.internal.dataForTable.filters.customer_created_at[0].items)}
                              filter={data => this.filterTable('customer_created_at', data)}
                              selected={this.state.customer_created_at}
                              // category={'MODULES'}
                              module={'BUTTONS'}
                              className={'mr-10'}
                            />
                            <CustomSelect
                              title={this.props.translate.i18n.MODULES.CUSTOMERS.CONSENT_GDPR_AT}
                              data={toJS(this.props.internal.dataForTable.filters.consent_gdpr_at[0].items)}
                              filter={data => this.filterTable('consent_gdpr_at', data)}
                              selected={this.state.customer_created_at}
                              // category={'MODULES'}
                              module={'BUTTONS'}
                              className={'mr-10'}
                            />
                            <CustomSelect
                              title={this.props.translate.i18n.MODULES.CUSTOMERS.CONSENT_NEWSLETTER_AT}
                              data={toJS(this.props.internal.dataForTable.filters.consent_newsletter_at[0].items)}
                              filter={data => this.filterTable('consent_newsletter_at', data)}
                              selected={this.state.customer_created_at}
                              // category={'MODULES'}
                              module={'BUTTONS'}
                            />
                        </div>
                        
                        {this.state.loadingTable
                            ?
                            <CircularProgress className={'circular-progress'} />
                            :
                            // null
                            <CustomTable
                                dropDownMenuItems={this.dropDownMenuItems}
                                module={'/customers'}
                                handleChangeRowsPerPage={this.handleChangeRowsPerPage}
                                handleChangePage={this.handleChangePage}
                                handleSort={this.handleSort}
                                header={this.tableHeader}
                                body={this.tableBody}
                                // openDialogSiblings={this.openCloseDialogChangePosition}
                                // clickOnProductionStatus={this.clickOnProductionStatus}
                                // handleChangeType={this.handleChangeType}
                                // disablePagination={true}
                                // disableSort
                                // changeItems={this.changeItems}
                            />
                        }
                      </div>
                </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/screens/Customers/Customers.jsx